import { render, staticRenderFns } from "./VipHead.vue?vue&type=template&id=dc12ac92&lang=html"
import script from "./VipHead.vue?vue&type=script&lang=js"
export * from "./VipHead.vue?vue&type=script&lang=js"
import style0 from "./VipHead.vue?vue&type=style&index=0&id=dc12ac92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports